import React, { useEffect } from 'react';
import { Alert, SnackbarOrigin } from '@mui/material';
import { RouteParams } from 'app/models/Orders/Order';
import { useLocation, useParams } from 'react-router-dom';
import { OrderDetailsContent } from './OrderDetailsContent';
import { OrderBody } from './OrderDetailsDesign';
import { navigationStickActions } from 'app/components/GlobalNavigationMenu/NavigationStick.redux';
import { trackPageView, usePageLoadingTracker, usePageVisitTimeTracker } from 'app-insights/appInsightsTracking';
import useDocumentTitle from 'utils/customHooks/useDocumentTitle';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectRateCardValidationError } from 'store/redux-store/create-order-ocbr/selector';
import { globalActions } from 'app/ApplicationRoot/Global.redux';

interface SnackbarState extends SnackbarOrigin {
  snackOpen: boolean;
}

export const OrderDetailsWrapper = () => {
  const [snackbarState, setSnackbarState] = React.useState<SnackbarState>({
    snackOpen: false,
    vertical: 'top',
    horizontal: 'center',
  });

  const params = useParams<RouteParams>();
  const location = useLocation();
  const dispatch = useDispatch();
  usePageVisitTimeTracker('Order Details');
  useDocumentTitle({ title: `OID ${params.id}` });
  usePageLoadingTracker(); // Must come after the document title is set
  const { t } = useTranslation();
  const isRateCardValidationError = useSelector(selectRateCardValidationError);

  useEffect(() => {
    trackPageView({ name: `OID ${params.id}` });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state === 'newOrder') {
      setSnackbarState({ ...snackbarState, snackOpen: true });
      setTimeout(() => {
        setSnackbarState({ ...snackbarState, snackOpen: false });
        window.history.replaceState({}, document.title);
      }, 3000);
    } else setSnackbarState({ ...snackbarState, snackOpen: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    dispatch(navigationStickActions.setSelectedMenuByKey('order'));
    dispatch(navigationStickActions.setSelectedSubMenu(undefined));
    return () => {
      dispatch(globalActions.closeBanner());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isRateCardValidationError && <Alert severity="error">{t('order.newOrder.rateCard.warringMessage')}</Alert>}
      <OrderBody data-testid="test-order-details">
        <OrderDetailsContent id={params.id} />
      </OrderBody>
    </>
  );
};
